import { FC, useContext } from 'react'
import { toBytes } from '../../../../../utils/bytes'

import { FilePicker } from '../../../../core/FilePicker'
import { useFilePicker } from '../hooks'
import { RegisterModalContext } from '../RegisterSongModal'

export const ProjectFilePicker: FC = () => {
  const { setProjectFile, setProjectFileErrors } = useContext(RegisterModalContext)
  const { getRootProps, getInputProps } = useFilePicker({
    maxFileSizeBytes: toBytes(100, 'MB'),
    acceptedFileTypes: ['als', 'flp'],
    onDropAccepted: (file) => setProjectFile(file),
    onDropRejected: (fileErrors) => setProjectFileErrors(fileErrors),
    restrictAcceptedFiles: false
  })

  return (
    <FilePicker
      title="Add or drop project file"
      getRootProps={getRootProps}
      getInputProps={getInputProps}
      description="Supports .als and .flp only"
    />
  )
}
